module.exports = __webpack_public_path__ + "img/gx.1b107451.webp";